import styles from './styles.module.scss'

interface LoadingProps {
  type?: string
}

export default function Loading({ type }: LoadingProps) {
  const containerClass = type
    ? `${styles.loadingContainer} ${styles[type] || ''}`
    : styles.loadingContainer

  return (
    <div className={containerClass}>
      <div className={styles.loadingInner}>
        <img src='/images/loading.gif' alt='NowLoading' loading='eager' />
      </div>
    </div>
  )
}
